module.exports = __webpack_public_path__ + "static/media/Calendar.42cd6a54.svg";